import React from 'react';
import { Project } from '../../services/projectService';
import { formatProjectDate, getProjectCardTheme, getProjectStatusBadges } from './projectCardTheme';

interface Props {
  projects: Project[];
  onProjectClick: (projectId: string) => void;
}

const ProjectDashboardBoard: React.FC<Props> = ({ projects, onProjectClick }) => (
  <div className="overview-grid">
    {projects.map((project) => {
      const theme = getProjectCardTheme(project);
      const badges = getProjectStatusBadges(theme, project);
      const pct = Math.min(100, Math.max(0, project.taskCompletion?.percent ?? 0));
      const completed = project.taskCompletion?.completed ?? 0;
      const total = project.taskCompletion?.total ?? 0;
      return (
        <button
          key={project._id}
          type="button"
          className={`overview-card is-${theme}${project.hasUnreadActivity ? ' has-activity' : ''}`}
          onClick={() => onProjectClick(project._id)}
        >
          <span className="overview-card-bar" />
          <span className="overview-card-body">
            <span className="overview-card-head">
              <strong>{project.name}</strong>
              <span className="dash-list-badges">
                {project.hasUnreadActivity && (
                  <span className="activity-badge">
                    <i />
                    New activity
                  </span>
                )}
                {badges.map((badge) => (
                  <span key={badge.label} className={`dash-status-badge is-${badge.tone}`}>
                    {badge.label}
                  </span>
                ))}
              </span>
            </span>
            <p>{project.description || 'No description provided'}</p>
            <span className="overview-card-dates">
              <span>
                <em>Start date</em>
                <b>{formatProjectDate(project.startDate)}</b>
              </span>
              <span className={theme === 'critical' || theme === 'warning' ? `is-${theme}` : ''}>
                <em>End date</em>
                <b>{formatProjectDate(project.endDate)}</b>
              </span>
            </span>
            <span className="overview-card-progress">
              <span className="dash-list-progress-copy">
                <span>Completed</span>
                <strong>{pct}%</strong>
              </span>
              <span className={`dash-progress-track is-${theme} is-thick`}>
                <span style={{ width: `${pct}%` }} />
              </span>
              <span className="overview-card-tasks">
                {completed} / {total} tasks finished
              </span>
            </span>
          </span>
        </button>
      );
    })}
  </div>
);

export default ProjectDashboardBoard;
